module.exports = "https://beta.voredev.ru/assets/index/massengers-ee8062473fd0c7a4403aac33fda2f2fc.png";